<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">運送形態詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_TM_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="form.id"
                :rules="codeRules"
                clearable
                label="運送形態 CD"
                v-model.trim="form.code"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :rules="nameRules"
                clearable
                label="運送形態 名称"
                v-model="form.name"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      form: {
        name: null,
      },
      nameRules: [(v) => !!v || "運送形態 名称 is required"],
      codeRules: [(v) => !!v || "運送形態 CD is required"],
      errors: {
        CODE_EXISTS: "当該CDは既に存在しています。",
      },
    };
  },
  methods: {
    save() {
      this.$http
        .post("/transport-modes", this.form)
        .then(() => {
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
  },
};
</script>
